import { observer } from "mobx-react-lite";
import * as React from "react";
import { onError } from "src/common/onError";

import { QueryBuilderFiltersManager } from "../../QueryBuilderFiltersManager";
import { QueryBuilderDescriptionModal } from "../QueryBuilderDescriptionModal/QueryBuilderDescriptionModal";
import { QueryBuilderModal } from "../QueryBuilderModal/QueryBuilderModal";
import { QueryBuilderTemplatesModal } from "../QueryBuilderTemplatesModal/QueryBuilderTemplatesModal";

type PropsQueryBuilderManagerFacade = {
  manager: QueryBuilderFiltersManager;
};

export const QueryBuilderManagerFacade: React.FC<PropsQueryBuilderManagerFacade> =
  observer(({ manager }) => {
    const handleCancelQueryBuilderModal = () => {
      manager.setQueryBuilderModalOpen(false);
    };

    const handleResetDraft = () => {
      manager.resetCurrentFilter().catch(onError);
    };

    const handleResetConditions = () => {
      manager.resetConditions();
    };

    const handleApplyDraft = () => {
      manager.applyDraft();
    };

    const handleSaveTemplate = () => {
      manager.saveAsTemplate();
    };

    const handleOpenTemplatesModal = () => {
      manager.setTemplatesModalOpen(true);
    };

    const handleCloseTemplatesModal = () => {
      manager.setTemplatesModalOpen(false);
    };

    const handleDeleteTemplate = React.useCallback(
      (id: string) => {
        manager.deleteTemplate(id);
      },
      [manager],
    );

    const handleSelectTemplate = () => {
      manager.selectTemplateFromModal();
    };

    const handleTemplateDescriptionChange = (value: string) => {
      manager.queryBuilderStore.draftStore.setTemplateDescription(value);
    };

    const handleCancelSaveTemplate = () => {
      manager.setSaveTemplateModalOpen(false);
    };

    const handleConfirmSaveTemplate = () => {
      manager.confirmSaveAsTemplate();
    };

    return (
      <>
        <QueryBuilderModal
          open={manager.isQueryBuilderModalOpen}
          store={manager.queryBuilderStore}
          onCancel={handleCancelQueryBuilderModal}
          onReset={handleResetDraft}
          onResetConditions={handleResetConditions}
          onApply={handleApplyDraft}
          onSaveTemplate={handleSaveTemplate}
          onChooseTemplate={handleOpenTemplatesModal}
          canSaveTemplate={manager.canSaveAsTemplate}
        />

        {manager.templatesTableStore && (
          <QueryBuilderTemplatesModal
            open={manager.isTemplatesModalOpen}
            canSelectTemplate={manager.canSelectTemplate}
            tableStore={manager.templatesTableStore}
            onClose={handleCloseTemplatesModal}
            onDelete={handleDeleteTemplate}
            onSelect={handleSelectTemplate}
          />
        )}

        <QueryBuilderDescriptionModal
          open={manager.isSaveTemplateModalOpen}
          description={manager.queryBuilderStore.draftStore.templateDescription}
          onChange={handleTemplateDescriptionChange}
          onCancel={handleCancelSaveTemplate}
          onContinue={handleConfirmSaveTemplate}
        />
      </>
    );
  });
